import { render, staticRenderFns } from "./TextAreaEditor.vue?vue&type=template&id=6f74c09c&scoped=true&"
import script from "./TextAreaEditor.vue?vue&type=script&lang=js&"
export * from "./TextAreaEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f74c09c",
  null
  
)

export default component.exports